import EmptyPage from '../../components/empty-page/emptyPage';

const OrgInsights = () => {
    return <EmptyPage />;
};

export default OrgInsights;
